export default __webpack_public_path__ + "static/media/home2.f8236e64.webp";